import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {
  DataObjectId,
  DeadlineStickerEntry,
  DeadlineStickerValue,
  Hub,
  HubLike,
  RangePoint,
  StickerType,
  Tag,
  TaskData
} from 'yougile-model'
import {Sync} from '@client/sync'
import {Gantt} from '@extensions/gantt'
import {stickerCtl} from '@extensions/sticker/sticker'
import {Task} from '@extensions/task'
import {
  isStickerHubCompleted,
  StickerContainerKey,
  StickerHub
} from '../views-web/a-sticker-view'
import {ASystemStickerCtl} from './a-system-sticker-ctl'

export class DeadlineCtl extends ASystemStickerCtl<DeadlineStickerValue> {
  public requestedValue:
    | {taskId: DataObjectId | undefined; container: StickerContainerKey}
    | undefined

  public override onPinEmpty(
    task: Hub,
    _: Tag,
    container: StickerContainerKey
  ): void {
    this.requestedValue = {taskId: task.id, container}
  }

  public override get title(): string {
    return 'Deadline'
  }

  public get type(): StickerType {
    return 'deadline'
  }

  public displayedTitle(tag: Tag): string {
    if (tag.title === 'Deadline') {
      return Lang.msg.deadline
    } else {
      return tag.title
    }
  }

  public static formatDeadline(value: DeadlineStickerEntry): string {
    const {deadline, withTime, startDate} =
      value || ({} as DeadlineStickerEntry)
    const timeSuff = withTime
      ? ` ${Lang.msg.at} ` + Time.formatShort(deadline, true)
      : ''
    return Time.formatRange(startDate, deadline) + timeSuff
  }

  public static isSpoiled(
    value: {
      deadline?: number
      withTime?: boolean
    },
    opts: {
      task?: StickerHub
      taskData?: TaskData
    }
  ): boolean {
    if (!value?.deadline) {
      return false
    }
    if (isStickerHubCompleted(opts.task)) {
      return false
    }
    if (opts.taskData?.completeTime) {
      return false
    }
    if (value.withTime) {
      return value.deadline < Time.now()
    } else {
      return Time.startOfDay(value.deadline) < Time.startOfDay(Time.now())
    }
  }

  public static getBlockedPoints(hub: HubLike): RangePoint[] {
    if (!Task.shouldAutoPlan(hub)) {
      return []
    }

    const box = Sync.getCurrentSandbox()
    const deadlineTag = stickerCtl.Deadline.getSticker(box)

    const linkedFrom = Gantt.getLinkedFromHubs(hub)
    const blockingLinkedFrom = linkedFrom.filter(x => {
      const deadline = x.stickers[deadlineTag.id] as
        | DeadlineStickerValue
        | undefined
      return !!deadline?.current?.deadline
    })
    if (blockingLinkedFrom.length) {
      // A task is blocked from modifying deadline start if it is or some of its
      // parent tasks are on a board w/ auto planning enabled and has dependencies
      // with a deadline.
      return ['start']
    }

    return []
  }
}
